import React from 'react'
import './style.sass'

export default () => (<div className='component branding'>
  <div className='real-name'>#amazingandyyy</div>
  <div className='name gradient-txt'>Andy Chen</div>
</div>)
